const LikeIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill="#EEF2FF" />

      <path
        d="M20 22V32H16C15.4 32 15 31.6 15 31V23C15 22.4 15.4 22 16 22H20ZM22 22L26 14C26.5 13 28 13.5 28 14.8V22H31C32.1 22 33 22.9 33 24C33 24.2 33 24.4 32.9 24.6L30.8 31.6C30.5 32.5 29.7 33 28.8 33H22V22Z"
        fill="#1E1B6A"
      />
    </svg>
  );
};

export default LikeIcon;
